import { request } from "./api";

export const projectApiCall = request;
export const addStudies = (pubs) => request("POST", "/studies", { pubs });
export const addProject = (project) => request("POST", "/projects", project);
export const updateProject = (id, project) => request("PUT", `/projects/${id}`, project);
export const deleteProject = (id) => request("DELETE", `/projects/${id}`);
export const deleteStudy = (id) => request("DELETE", `/studies/${id}`);
export const getPubmedDetails = (pmid) => request("GET", `/pubmed/${pmid}`);
